<script setup lang="ts">
import { BaseCard } from '@/components/Cards'
import InformationBaseCard from '@/components/Cards/InformationBaseCard.vue'
import { StackLayout } from '@/components/Layouts'
import { type UserModel } from '@/types/models/UserModel'

type Props = {
    me: UserModel
}
defineProps<Props>()
</script>

<template>
    <InformationBaseCard :label="$t('account.rolesTitle')">
        <StackLayout :gap="8" wrap>
            <BaseCard
                v-for="(role, key) in me.roles"
                :key="key"
                class="profile-role-card fit-content">
                <template #content>
                    {{ role }}
                </template>
            </BaseCard>
        </StackLayout>
    </InformationBaseCard>
</template>

<style lang="scss">
.profile-role-card {
    & .card-content {
        text-align: center;
        border: 1px solid $primary;
    }
}
</style>
